import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ServiceNotificationsState } from './service-notifications.models';

export const selectServiceNotificationsState = createFeatureSelector<ServiceNotificationsState>('serviceNotifications');

export const selectAllServiceNotifications = createSelector(
  selectServiceNotificationsState,
  (state) => state.notifications
);

export const selectUnreadServiceNotifications = createSelector(
  selectServiceNotificationsState,
  (state) => state.notifications.filter(n => !n.read)
);

export const selectServiceNotificationsLoading = createSelector(
  selectServiceNotificationsState,
  (state) => state.loading
);

export const selectServiceNotificationsError = createSelector(
  selectServiceNotificationsState,
  (state) => state.error
);

export const selectHasUnreadNotifications = createSelector(
  selectAllServiceNotifications,
  (notifications): boolean => {
    if (!notifications || notifications.length === 0) return false;
    return notifications.some(n => !n.read);
  }
);
